// @flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import styled from 'styled-components';
import type { Theme } from '../../types';
import withDidAppear from '../withDidAppear';
import { onCheckoutStep } from '../../store/gtm';
import { getLocation } from '../../store/router';
import scrollToAnchor from '../../helpers/scrollToAnchor';

const Container = styled<any, Theme>('section')`
  display: block;

  /* The rules below are added to make sure the anchor is in the right position */
  /* This will fix that config the heading won't go behind the sticky menu */
  padding-top: 7rem;
  margin-top: -5rem;
  &.step-1 {
    margin-top: -7rem;
  }
  border-bottom: solid 1px ${props => props.theme.configBuilderGroup.borderColor};
`;

type DispatchProps = {|
  onContainerAppear: Function,
|};

type StateProps = {|
  hash: string,
|};

type OwnProps = {|
  children: Node,
  step: number,
  id: string,
  hash: string,
|};

type Props = {|
  ...OwnProps,
  ...DispatchProps,
  ...StateProps,
|};

class ConfigBuilderGroupContainer extends Component<Props> {
  componentDidMount() {
    const { hash, id } = this.props;
    // on page load this makes shure that if there is a # in the URL,
    // it gets redirected to the correct section
    if (hash === `#${id}`) {
      scrollToAnchor({ anchorId: `container-${id}` });
    }
  }

  componentDidAppear = () => {
    const { step, onContainerAppear } = this.props;
    onContainerAppear(step + 1);
  }

  render() {
    const { children, id, step } = this.props;
    return (
      <Container className={`step-${step + 1}`} id={`container-${id}`}>{children}</Container>
    );
  }
}

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onContainerAppear: (step: number) => dispatch(onCheckoutStep(step)),
});

const mapStateToProps = (state): StateProps => ({
  hash: (getLocation(state) || {}).hash,
});

export default compose(
  connect<Props, OwnProps, StateProps, DispatchProps, any, any>(
    mapStateToProps,
    mapDispatchToProps,
  ),
  c => withDidAppear(c, true),
)(ConfigBuilderGroupContainer);
